import { BaseSelect, Select, SelectProps } from '@app/components';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { PromotionScope } from '@app/common';
import React from 'react';

const columnHelper = createColumnHelper<PromotionScope>();

export const getScopeFR = (scope: PromotionScope) => {
  switch (scope) {
    case PromotionScope.CART:
      return "Le panier";
    case PromotionScope.CATALOG:
      return "Les catégories";
  }
}

// TODO: Remplacer cette méthode par l'input attendu ( un objet ) via transform

// React Hook form oblige les fieldArrays à être des objets et non des string afin
// d'ajouter une propriété "id" sur chaque value. Sans ça, la value devient un objet destructuré + le champ id.
// Ici, je join la string destructuré sans l'id.
const destructuredReactHookFormValueToString = (item: any): any => {
  const arr = Object.values(item);

  arr.splice(-1);

  return arr.join('');
}

const columns = [
  columnHelper.display({
    id: 'scope',
    header: () => (
      <BaseSelect.ListHeaderItem width="100%">
        Afficher dans
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => {
      return <BaseSelect.ListItemCol width="100%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {getScopeFR(info.row.original)}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    },
  }),
];

export const PromotionScopeSelect = ({ label = 'Afficher dans', ...props }: Omit<SelectProps<any>, 'table'>) => {
  const table = useReactTable({
    data: Object.values(PromotionScope),
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Select
      label={label}
      table={table}
      transform={{
        accessor: (item) => {
          if (typeof item === 'string') {
            return item;
          }

          return destructuredReactHookFormValueToString(item);
        },
        value: (item) => item,
        display: (item) => getScopeFR(destructuredReactHookFormValueToString(item))
      }}
      {...props} />
  );
};
